import React from 'react';
import { ShieldCheck, ArrowUpRight, Handshake, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import QuoteCalculator from './QuoteCalculator';
import { HERO_IMAGES, COMPANY } from '../mock';

const Hero = () => {
  return (
    <section id="quote" className="relative overflow-hidden bg-[#0A1628]">
      {/* Layered background */}
      <div className="absolute inset-0 z-0 brand-gradient-tech" />
      <div className="absolute inset-0 z-0 circuit-bg-dark opacity-60" />
      <div className="absolute inset-0 z-0">
        <img src={HERO_IMAGES.main} alt="Excelence Inc auto hauler on US highway at sunrise" className="w-full h-full object-cover opacity-30 mix-blend-luminosity" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0A1628]/90 via-[#0A1628]/75 to-[#0E2744]/60" />
      </div>
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[#2AA8E8]/20 blur-3xl z-0" />
      <div className="absolute -bottom-32 -right-32 w-[28rem] h-[28rem] rounded-full bg-[#D4A24C]/15 blur-3xl z-0" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 pt-12 md:pt-16 pb-16 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">
          {/* Left: headline */}
          <div className="lg:col-span-3 text-white">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#2AA8E8]/10 backdrop-blur-sm border border-[#2AA8E8]/30 text-xs font-semibold mb-6 text-[#2AA8E8]">
              <ShieldCheck className="w-3.5 h-3.5" />
              Fully insured · {COMPANY.mc} · {COMPANY.dot}
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.05] tracking-tight mb-5">
              <span className="block">Precision Logistics.</span>
              <span className="block text-[#2AA8E8]">Elite Performance.</span>
              <span className="block gold-text">Nationwide Reach.</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
              We don't just move vehicles — we lead the market with a systematic, technology-driven approach to auto transportation. Experience the Excelence standard of speed, communication and reliability.
            </p>

            <div className="flex flex-wrap gap-3 mb-10">
              <a href="/#quote">
                <Button data-testid="hero-elite-quote-btn" className="btn-accent font-bold h-12 px-6 gap-2">
                  <Sparkles className="w-4 h-4" /> Get Elite Quote
                </Button>
              </a>
              <a href="/partners">
                <Button data-testid="hero-partner-btn" variant="outline" className="h-12 px-6 border-white/30 text-white bg-white/5 hover:bg-white hover:text-[#0A1628] font-semibold gap-2 backdrop-blur-sm">
                  <Handshake className="w-4 h-4" /> Become a Partner
                  <ArrowUpRight className="w-4 h-4" />
                </Button>
              </a>
            </div>

            {/* Marquee: brand pillars */}
            <div className="overflow-hidden border-t border-white/15">
              <div className="tagline-track py-5 flex items-center gap-10 text-xl md:text-2xl font-extrabold uppercase tracking-wider">
                {Array.from({ length: 6 }).map((_, i) => (
                  <React.Fragment key={i}>
                    <span className="whitespace-nowrap text-white">Precision.</span>
                    <span className="text-[#2AA8E8]">•</span>
                    <span className="whitespace-nowrap text-white">Performance.</span>
                    <span className="text-[#D4A24C]">•</span>
                    <span className="whitespace-nowrap text-white">Nationwide.</span>
                    <span className="text-[#2AA8E8]">•</span>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Quote Calculator */}
          <div className="lg:col-span-2">
            <QuoteCalculator />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
